import React from "react";
import { Link, useNavigate } from "react-router-dom";
import Cookies from "js-cookie";

export default function Dashboard4() {
  const user = JSON.parse(Cookies.get("user"));
  console.log(user);
  let navigate = useNavigate();

  return (
    <>
      <div className="flex flex-row">
        <aside className="w-48 h-screen" aria-label="Sidebar">
          <div className="overflow-y-auto py-4 px-3 bg-gray-800 h-screen">
            <ul className="space-y-2">
              <li>
                <Link
                  to={"/dashboard/"}
                  className="flex items-center p-2 text-base font-normal rounded-lg text-white hover:bg-gray-700"
                >
                  <svg
                    aria-hidden="true"
                    className="w-6 h-6 text-gray-500 transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-white"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M2 10a8 8 0 018-8v8h8a8 8 0 11-16 0z" />
                    <path d="M12 2.252A8.014 8.014 0 0117.748 8H12V2.252z" />
                  </svg>
                  <span className="ml-3">Dashboard</span>
                </Link>
              </li>
              <li>
                <Link
                  to={"/dashboard/list-job-vacancy"}
                  className="flex items-center p-2 text-base font-normal rounded-lg text-white hover:bg-gray-700"
                >
                  <svg
                    aria-hidden="true"
                    className="flex-shrink-0 w-6 h-6 text-gray-500 transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-white"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M10 2a4 4 0 00-4 4v1H5a1 1 0 00-.994.89l-1 9A1 1 0 004 18h12a1 1 0 00.994-1.11l-1-9A1 1 0 0015 7h-1V6a4 4 0 00-4-4zm2 5V6a2 2 0 10-4 0v1h4zm-6 3a1 1 0 112 0 1 1 0 01-2 0zm7-1a1 1 0 100 2 1 1 0 000-2z"
                      clip-rule="evenodd"
                    ></path>
                  </svg>
                  <span className="ml-3">List Job Table</span>
                </Link>
              </li>
              <li>
                <Link
                  to={"/dashboard/list-job-vacancy/form"}
                  className="flex items-center p-2 text-base font-normal rounded-lg text-white hover:bg-gray-700"
                >
                  <svg
                    aria-hidden="true"
                    className="flex-shrink-0 w-6 h-6 text-gray-500 transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-white"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M5 3a2 2 0 00-2 2v2a2 2 0 002 2h2a2 2 0 002-2V5a2 2 0 00-2-2H5zM5 11a2 2 0 00-2 2v2a2 2 0 002 2h2a2 2 0 002-2v-2a2 2 0 00-2-2H5zM11 5a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V5zM11 13a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z" />
                  </svg>
                  <span className="flex-1 ml-3 whitespace-nowrap">
                    Add new Job
                  </span>
                </Link>
              </li>
              <li>
                <Link
                  to={"/dashboard/profile"}
                  className="flex items-center p-2 text-base font-normal rounded-lg text-white hover:bg-gray-700"
                >
                  <svg
                    aria-hidden="true"
                    className="flex-shrink-0 w-6 h-6 text-gray-500 transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-white"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z"
                      clip-rule="evenodd"
                    ></path>
                  </svg>
                  <span className="flex-1 ml-3 whitespace-nowrap">Profile</span>
                </Link>
              </li>
              <li>
                <Link
                  to={"/dashboard/reset-password"}
                  className="flex items-center p-2 text-base font-normal rounded-lg text-white hover:bg-gray-700"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="flex-shrink-0 w-6 h-6 text-gray-500 transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-white"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M8 7a5 5 0 113.61 4.804l-1.903 1.903A1 1 0 019 14H8v1a1 1 0 01-1 1H6v1a1 1 0 01-1 1H3a1 1 0 01-1-1v-2a1 1 0 01.293-.707L8.196 8.39A5.002 5.002 0 018 7zm5-3a.75.75 0 000 1.5A1.5 1.5 0 0114.5 7 .75.75 0 0016 7a3 3 0 00-3-3z"
                      clip-rule="evenodd"
                    />
                  </svg>

                  <span className="flex-1 ml-3 whitespace-nowrap">
                    Change Pass
                  </span>
                </Link>
              </li>
              {Cookies.get("token") && (
                <li>
                  <span
                    className="cursor-pointer flex items-center p-2 text-base font-normal rounded-lg text-white hover:bg-gray-700"
                    onClick={() => {
                      Cookies.remove("token");
                      navigate("/login");
                    }}
                  >
                    <svg
                      aria-hidden="true"
                      className="flex-shrink-0 w-6 h-6 text-gray-500 transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-white"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M3 3a1 1 0 00-1 1v12a1 1 0 102 0V4a1 1 0 00-1-1zm10.293 9.293a1 1 0 001.414 1.414l3-3a1 1 0 000-1.414l-3-3a1 1 0 10-1.414 1.414L14.586 9H7a1 1 0 100 2h7.586l-1.293 1.293z"
                        clip-rule="evenodd"
                      ></path>
                    </svg>
                    <span className="flex-1 ml-3 whitespace-nowrap">
                      Logout
                    </span>
                  </span>
                </li>
              )}
            </ul>
          </div>
        </aside>

        <section className="bg-white">
          <div className="flex flex-row p-24">
            <img
              className="w-full rounded-full border-2 border-black mt-4"
              style={{
                resizeMode: "contain",
                height: 300,
                width: 300,
              }}
              src={user.image_url}
              alt="dashboard image"
            />
            <div className="border-2 border-black mx-20 rounded-2xl p-5 bg-gray-200 w-96">
              <h2 className="mb-4 text-4xl tracking-tight font-extrabold text-gray-900">
                {user.name}
              </h2>
              <p className="mb-4 font-light text-black md:text-lg font-semibold">
                Email : {user.email}
              </p>
              <p className="mb-4 font-light text-black md:text-lg">
                Account id : {user.id}
              </p>
              <p className="mb-4 font-light text-black md:text-lg">
                Created at : {user.created_at}
              </p>
              <p className="mb-4 font-light text-black md:text-lg">
                Update at : {user.updated_at}
              </p>

              <Link
                to="/dashboard/reset-password"
                className="inline-flex items-center text-white bg-indigo-700 hover:bg-indigo-800 focus:ring-4 focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center"
              >
                Change Password
                <svg
                  className="ml-2 -mr-1 w-5 h-5"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z"
                    clipRule="evenodd"
                  />
                </svg>
              </Link>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
